import client from "services/ngage/api-client";
import DataResource from "types/DataResource";
import {snakeKeys} from "../array";
import {Voucher} from "../../types/Voucher";
import deserializeVoucher from "./deserializers/voucher";
import {Offer} from "../../types/Offer";

type VoucherFilters = {
    holder?: number
    page?: number
    perPage?: number
}

/**
 * Get all vouchers that match the given filters (paginated)
 */
const filtered = async (filters: VoucherFilters = {}) => {
    const params = Object.assign({page: 1, per_page: 100}, snakeKeys(filters))
    const response = await client.get<DataResource<Voucher> | null>('/vouchers', {params})

    if (response.data) {
        response.data.data = response.data.data.map(deserializeVoucher)
    }

    return response.data
}

/**
 * Get a single voucher
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<Offer>(`/vouchers/${id}`)
    return response.data? deserializeVoucher(response.data) : null
}

const vouchers = {
    filtered,
    get,
}

export default vouchers;